import {Injectable} from '@angular/core';
import {isUndefined} from 'util';
/**
 * Created by Rumyantsev Daniil on 13.03.2018.
 */

declare var $: any;

@Injectable()
export class LoaderService {

  private static MAIN_PAGE_ID = 'main-page';

  showSpinner(blockId?: string) {

    if (isUndefined(blockId)) {
      blockId = LoaderService.MAIN_PAGE_ID;
    }

    // console.debug("SHOW BLOCK ID: ", "#" + blockId);

    let block = $("#" + blockId);

    // Если модальный блок уже создан - выход
    if ($("#" + blockId + "-modal").length) {
      // console.debug("BLOCK ALREADY EXISTS: ", "#" + blockId + "-modal");
      return;
    }

    const modal = $('<div/>').attr('id', blockId + "-modal");
    modal.addClass('loader-modal');
    // Без этого модальное окно покрывает страницу не полностью
    if (blockId == LoaderService.MAIN_PAGE_ID) {
      modal.height($(document).height());
    }
    modal.appendTo(block);

    $('<div/>').attr('id', blockId + "-loader")
      .appendTo("#" + blockId + "-modal").addClass('loader');

  }

  hideSpinner(blockId?: string) {

    if (isUndefined(blockId)) {
      blockId = LoaderService.MAIN_PAGE_ID;
    }
    // console.debug("HIDE BLOCK ID: ", "#" + blockId + "-modal");
    const modal = $("#" + blockId + "-modal");
    // Если модальный блок уже удален - выход
    if (!modal.length) {
      // console.debug("BLOCK ALREADY DELETED: ", "#" + blockId + "-modal");
      return;
    }
    $(modal).remove();
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/loader.service.ts